<template>
	<NuxtLayout>
		<div class="newsletter container" v-if="!isNewsletterFormSent">
			<h1 v-text="page.title" />
			<div class="newsletter__FormWrapper">
				<h2 v-text="$t('newsletter.pageSubtitle')" />
				<form @submit.prevent="submitNewsletter" class="absoluteLabelsForm">
					<TextField v-model="form.email" :label="$t('forms.email')" type="email" :errors="formErrors?.field_errors?.email" />
					<FieldGroup :inline="true">
						<TextField v-model="form.first_name" :label="$t('forms.firstName')" :errors="formErrors?.field_errors?.first_name" />
						<TextField v-model="form.last_name" :label="$t('forms.lastName')" :errors="formErrors?.field_errors?.last_name" />
					</FieldGroup>
					<SelectField
						class="form__HalfWidthField"
						v-model="form.gender"
						:options="genderOptions"
						:label="$t('forms.gender')"
						:errors="formErrors?.field_errors?.gender"
					/>
					<SelectField
						v-model="form.language_code"
						:options="communicationOptions"
						:label="$t('forms.preferredLanguage')"
						:errors="formErrors?.field_errors?.preffered_language"
					/>
					<FieldGroup :label="$t('accommodationTypes.placeholder')" class="normalFormLabel">
						<CheckboxField v-for="item in ['hotel', 'mobile_house', 'campsite']" v-model="form[item]" :label="$t(`accommodationTypes.${ item }`)" />
					</FieldGroup>

					<FieldGroup>
						<i18n-t tag="p" scope="global" keypath="newsletter.terms" class="newsletter__Terms">
							<template #link>
								<nuxt-link class="button__Text--Underline" :to="link('PrivacyPolicy')" target="_blank">{{ $t('newsletter.link') }}</nuxt-link>
							</template>
						</i18n-t>
					</FieldGroup>
					<Button type="button" class="newsletter__FormSubmitButton" medium full-width>{{ $t('newsletter.submit') }}</Button>
				</form>
			</div>
		</div>
		<div class="newsletterSuccess container" v-else>
			<Icon name="check-circle-fill" />
			<h2 v-text="$t('newsletter.successTitle')" />
			<p v-text="$t('newsletter.successText')" />
		</div>
	</NuxtLayout>
</template>

<script setup>
	import { communicationOptions } from '~/data/formsInitialData';

	const props = defineProps({
		page: {
			type: Object,
		},
	});

	const { t } = useI18n();
	const { query } = useRoute();
  const { link } = useSetup();
	const { lang } = useLanguage();

	const {
		public: {
			auth: { baseURL },
		},
	} = useRuntimeConfig();

	const isNewsletterFormSent = ref(false);

	const formErrors = ref(null);
	const { customError, setCustomError } = useCustomFormErrors(formErrors.value);

	const genderOptions = [
		{ title: t('genders.female'), value: 2 },
		{ title: t('genders.male'), value: 1 },
	];

	const form = ref({
		first_name: '',
		last_name: '',
		email: query.email,
		language_code: lang.value === 'sl' ? 'si' : lang.value,
		gender: '',
		hotel: false,
		mobile_house: false,
		campsite: false,
	});

	async function submitNewsletter() {
		customError.value = null;

		try {
			const response = await useClientFetch(`${baseURL}api/newsletter/subscribe`, {
				method: 'POST',
				body: JSON.stringify(form.value),
				headers: {
					'Application-Origin': 'SHAPE-WEB',
				},
			});

			isNewsletterFormSent.value = true;
		} catch (error) {
			if (error.data) formErrors.value = error.data;
			setCustomError(formErrors.value);
		}
	}
</script>

<style lang="scss">
	@import url('@/assets/styles/pages/_newsletter.scss');
</style>
